import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const BlueInfoIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="50" height="50" viewBox="0 0 512 512">
		<g transform="translate(0 0.39)">
			<circle cx="256" cy="256" r="256" transform="translate(0 -0.39)" fill="#54c9ff" opacity="0.15" />
			<path
				d="M0,216.392V103.468a22.361,22.361,0,0,1,44.722,0V216.392a22.361,22.361,0,1,1-44.722,0ZM0,22.361A22.361,22.361,0,1,1,22.361,44.722,22.361,22.361,0,0,1,0,22.361Z"
				transform="translate(234 136.61)"
				fill="#2b8097"
			/>
		</g>
	</svg>
);
